module.exports = __webpack_public_path__ + "static/media/going_up.a6240ece.svg";